var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", scrollable: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      _vm._b(
                        { attrs: { color: "error", icon: "" } },
                        "v-icon",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v(" mdi-delete-outline ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c("alert-remove-card", {
            on: {
              confirm: function ($event) {
                return _vm.submit()
              },
              close: function ($event) {
                return _vm.closeDialog()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }